import * as React from 'react'
import { homeService } from '../../../../../services'
import { Container, Message } from 'semantic-ui-react'

type MarqueeBannerState = {
  text: string,
}

export default class MarqueeBanner extends React.Component {
  state: MarqueeBannerState = {
    text: ''
  }

  componentDidMount() {
    homeService.getMarqueeText()
      .then(marquee => this.setState({
        text: marquee
      }))
  }

  render() {
    const { text } = this.state

    return (
      <Message error={true}>
        <Container textAlign={'center'}>
          <Message.Header>
              <div dangerouslySetInnerHTML={{ __html: text }} style={{ fontFamily: 'Serif', fontSize: '17' }} />
          </Message.Header>
        </Container>
      </Message>
    )
  }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/modules/HomeRoll/modules/RollItemStore/containers/MarqueeBanner.tsx